import { createContext, useContext } from 'react';

export interface CurrentUser {
  id?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  mobilePhone?: string;
  telephone?: string;
  jobTitle?: string;
  userProperties?: { cultureId?: string; spellCheck?: boolean; [key: string]: unknown };
}

export interface UserOrganization {
  id: number;
  name: string;
}

export interface UserContextValue {
  user: CurrentUser;
  organizations: UserOrganization[];
  selectedOrganization: number;
  selectOrganization: (id: number) => void;
  refreshOrganizations: () => void;
}

export const UserContext = createContext<UserContextValue | null>(null);

export const useUser = (): UserContextValue => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser used outside PageWrapper, which provides the user context');
  }
  return context;
};

export const useSelectedOrganization = (): number => {
  const context = useContext(UserContext);
  if (context?.selectedOrganization == null) {
    throw new Error('useSelectedOrganization used outside PageWrapper, which guarantees a selected organization');
  }
  return context.selectedOrganization;
};
